import "../style/form/doctorform.scss";
import React, { useEffect, useState, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import { sidebar } from "../redux/reducer/counterslice";
import Swal from "sweetalert2";
import { notification, notificationall } from "../../text/apidata";
import { useNavigate } from "react-router-dom";

//
import axios from "axios";

export default function Notification(props) {
  const sideactive = useSelector((state) => state.counter.sidebarnav);
  const [notificationdata, setnotificationdata] = useState({
    title: "",
    body: "",
    // uhid:"",
  });
  const settings = useNavigate();
  const dispatch = useDispatch();

  const [title, settitle] = useState("");
  const [body, setbody] = useState("");
  const [error, seterror] = useState(false);
  const [alert, setalert] = useState(false);
  const handleSubmit = (event) => {
    event.preventDefault();
  };

  const validate = (e) => {
    setalert(true);
    const { name, value } = e.target;

    if (name == "title") {
      if(e.target.value.length<="100"){

      settitle(e.target.value);
      setnotificationdata({
        ...notificationdata,
        [name]: e.target.value,
      });
    }
    } else if (name == "body") {
      setbody(e.target.value);
      setnotificationdata({
        ...notificationdata,
        [name]: e.target.value,
      });
    } else if (name == "uhid") {
      if (e.target.value.length == 0){
        setnotificationdata({
          ...notificationdata,
          [name]: null,
        });
      }
      else{
        setnotificationdata({
          ...notificationdata,
          [name]: e.target.value,
        });
      }
      
    }
  };

  const Notification = () => {
    if (
      notificationdata.body != "" &&
      notificationdata.title != "" &&
      notificationdata.uhid != "" &&
      notificationdata.uhid != undefined
    ) {
      Swal.fire({
        title: "Alert",
        text: "Notification Will be Sent to Respected UHID given",
        icon: "warning",

        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ok",
      }).then((result) => {
        if (result.isConfirmed) {
          axios({
            method: "post",
            url: notification,
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token") + "",
            },
            data: notificationdata,
          })
            .then((res) => {
              Swal.fire("Success!", "Notification Sent", "success");
              setnotificationdata({
                ...notificationdata,
                uhid: "",
                body: "",
                title: "",
              });
              settitle("");
              seterror(false);
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong Notification Not Sent!",
              });
            });
        }
      });
    } else {
      if (
        notificationdata.uhid == "" ||
        notificationdata.uhid == undefined ||
        notificationdata.body == "" ||
        notificationdata.title != ""
      ) {
        console.log(notificationdata.uhid);
        Swal.fire({
          title: "Validation Error",
          text: "Please fill all the field to Send Notification",
          icon: "warning",

          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Ok",
        }).then((result) => {
          if (result.isConfirmed) {
            seterror(true);
          }
        });
      }
    }
  };

  const Notificationall = () => {
    const formdata = new FormData();
    formdata.append("title", title);
    formdata.append("body", body);
    if (notificationdata.body != "" && notificationdata.title != "") {
      Swal.fire({
        title: "Alert",
        text: "Notification Will be Sent to All User",
        icon: "warning",

        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ok",
      }).then((result) => {
        if (result.isConfirmed) {
          axios({
            method: "post",
            url: notificationall,
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token") + "",
            },
            data: formdata,
          })
            .then((res) => {
              Swal.fire("Success!", "Notification Sent To All", "success");
              setnotificationdata({
                ...notificationdata,
                uhid: "",
                body: "",
                title: "",
              });
              settitle("");
              seterror(false);
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong Notification Not Sent!",
              });
            });
        }
      });
    } else {
      if (notificationdata.body == "" || notificationdata.title != "") {
        console.log(notificationdata.uhid);
        Swal.fire({
          title: "Validation Error",
          text: "Please fill all the field to Send Notification",
          icon: "warning",

          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Ok",
        }).then((result) => {
          if (result.isConfirmed) {
            seterror(true);
          }
        });
      }
    }
  };
  const cancelnewuser = () => {
    if (alert) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",

        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, revert it!",
      }).then((result) => {
        if (result.isConfirmed) {
          //Swal.fire("Reverted!", "Given Info has been Removed.", "success");
          setalert(false);
          dispatch(sidebar("DashBoard"));
          settings("/");
        }
      });
    } else {
      setalert(false);
      dispatch(sidebar("DashBoard"));
      settings("/");
    }
  };
  return (
    <>
      <div className={sideactive ? "doctorform-sa" : "doctorform"}>
        <div class="card">
          <div class="card-header">
            <h5 class="card-title" style={{ padding: "6px", margin: 0 }}>
              Notification
            </h5>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-sm">
                <form class="row g-3 needs-validation" onSubmit={handleSubmit}>
                  <div class="form-group col-md-4">
                    <label for="validationCustom01" class="form-label">
                      Title
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      id="validationCustom01"
                      name="title"
                      value={title}
                      onChange={(e) => validate(e)}
                      onKeyDown={(e) => {
                        if (e.target.value.length === 0 && e.which === 32) {
                          e.preventDefault();
                        }
                      }}
                      // onKeyDown={(e) => {
                      //   if (e.which == "32") {
                      //     e.preventDefault();
                      //   }
                      // }}
                      required
                    ></input>
                    <p style={{ fontSize: "12px", color: "red" }}>
                      {error && notificationdata.title == ""
                        ? "Title Required"
                        : ""}
                    </p>
                  </div>
                  <div class="form-group col-md-8 ">
                    <label for="validationCustom01" class="form-label">
                      Description
                    </label>
                    <textarea
                      type="textarea"
                      class="form-control"
                      id="validationCustom01"
                      name="body"
                      value={notificationdata.body}
                      style={{ resize: "none" }}
                      onChange={(e) => validate(e)}
                      onKeyDown={(e) => {
                        if (e.target.value.length === 0 && e.which === 32) {
                          e.preventDefault();
                        }
                      }}
                      rows="3"
                      required
                    ></textarea>
                    <p style={{ fontSize: "12px", color: "red" }}>
                      {error && notificationdata.body == ""
                        ? "Description Required"
                        : ""}
                    </p>
                  </div>
                  <div class="form-group col-md-4">
                    <label for="validationCustom01" class="form-label">
                      UHID
                    </label>
                    <input
                      type="number"
                      class="form-control"
                      id="validationCustom01"
                      name="uhid"
                      value={notificationdata.uhid}
                      onChange={(e) => validate(e)}
                      onKeyDown={(e) => {
                        if (e.target.value.length === 0 && e.which === 32) {
                          e.preventDefault();
                        }
                      }}
                    ></input>
                  </div>

                  <div class="col-10">
                    <button
                      class="btn btn-primary m-2"
                      type="submit"
                      onClick={(e) => {
                        Notification(e);
                      }}
                    >
                      Send Notification
                    </button>

                    <button
                      class="btn btn-primary m-2"
                      type="submit"
                      onClick={(e) => {
                        Notificationall(e);
                      }}
                      disabled={notificationdata.uhid==null?false:true}
                    >
                      Send Notification All
                    </button>
                  </div>
                  <div className="col-2">
                    <button
                      class="btn btn-danger"
                      style={{ float: "right" }}
                      onClick={(e) => cancelnewuser(e)}
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
